import React, {Component} from 'react';
import {Card, Grid} from 'semantic-ui-react';
import {fullDateShow} from '../../../../common/constants/datesFormat';
import moment from 'moment';

export class DispatchOrderInfoCard extends Component {
  render() {
    const {addDate, addUser, updateDate, updateUser} = this.props;
    return (
      <Card fluid className='card background grey'>
        <Grid columns='equal' padded className='low-padding' textAlign='right'>
          <Grid.Row>
            <Grid.Column textAlign='right'>
              Fecha de creación:
            </Grid.Column>
            <Grid.Column>
              {addDate ? moment(addDate).format(fullDateShow) : ''}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='right'>
              Creado por:
            </Grid.Column>
            <Grid.Column>
              {addUser}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='right'>
              Fecha última edición:
            </Grid.Column>
            <Grid.Column>
              {updateDate ? moment(updateDate).format(fullDateShow) : ''}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='right'>
            Editado por:
            </Grid.Column>
            <Grid.Column>
              {updateUser}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

export default DispatchOrderInfoCard;
